import { Router } from "./Routes/router";
import i18n from "i18next";
import './translations/i18n'
import { useEffect } from "react";
import { LanguageProvider } from "./contexts/LanguageContext";


export function App() {
  
  useEffect(() => {
    // Verificar se existe um idioma salvo no localStorage
    const savedLanguage = localStorage.getItem("language");
    
    if (savedLanguage) {
      // Se existe um idioma salvo, usar esse idioma
      i18n.changeLanguage(savedLanguage);
    } else {
      // Se não existe, usar o idioma padrão
      i18n.changeLanguage('pt-BR');
    }
  }, [])


  return (
    <LanguageProvider>
      <Router />
    </LanguageProvider>
  );
}
